module.exports = __webpack_public_path__ + "assets/img/1e439bd17c3e4c0c5d61ee26d01d6464.png";